import React, { Component } from 'react'
import { Link } from 'react-router-dom';
import { Guardian } from '@xaamin/guardian';
import { Button, Row, Col } from 'react-bootstrap';

import PacsList from './list/PacsList';
import PacsItemActions from './list/components/PacsItemActions';
import PacsStampingPoolActions from './list/components/PacsStampingPoolActions';

class Pacs extends Component {

  state = {
    selectedRowKeys: [],
    selectedRows: []
  }

  componentDidMount() {
    window.setAppTitle('Pacs');
  }

  handleOnRowSelectionChange = ({selectedRowKeys, selectedRows}) => {
    this.setState({
      selectedRowKeys,
      selectedRows
    });
  }

  handleOnRowClick = (data) => {
    this.props.history.replace({
      pathname: `/admin/pacs/${data.id}/info`,
      state: {
        data: {...data}
      }
    });
  }

  render() {
    const { selectedRowKeys, selectedRows } = this.state;

    return (
      <div>
        <Row className="mb-3">
          <Col>
            { Guardian.allows('pac.crear') && (
              <Link to="/admin/pacs/registrar" className="mr-3">
                <Button>
                  Nuevo Pac
                </Button>
              </Link>
            )}

            { selectedRowKeys.length > 0 && (
                <PacsItemActions
                  selectedRowKeys={ selectedRowKeys }
                  selectedRows={ selectedRows }
                />
              )
            }

            { selectedRowKeys.length === 0 && Guardian.allows('pac.estrategias') && (
                <PacsStampingPoolActions />
              )
            }

          </Col>

          <Col className="text-right">
            <h5 className="pt-2">
              Pacs
            </h5>
          </Col>
        </Row>

        { Guardian.allows('pac.listar') && (
          <PacsList
            onRowClick={ this.handleOnRowClick }
            onRowSelectionChange={ this.handleOnRowSelectionChange }
          />
        )}
      </div>
    )
  }
}

export default Pacs;